import React, { Component, Fragment } from 'react';
import { NavLink } from 'redux-first-router-link'; 
import { connect } from 'react-redux';
import './lander.scss'; //minisite-specific lander css file
import Loading from '../App/Loading'; // can be a hasLoading() HOC in the future
import MetaTags from '../common/MetaTags';
import OutboundLink from '../common/OutboundLink';
import TrackingPixels from '../common/TrackingPixels';
import { segmentTrackPage, segmentTrackEvent, sendLog } from '../../utils';
import { SITE_HOST } from '../../consts';

class Lander extends Component {
  constructor() {
    super();
    this.state = {
      
    };
    this.handleClick = this.handleClick.bind(this);
    this.renderArticles = this.renderArticles.bind(this);
  }

  handleClick(e) {

      //include any specific click handling for articles/sections

      //tracking code
      const { target } = e;
      const targetTagName = target.tagName.toLowerCase();
      let trackableElement = target;
      let innerHTML = '';
      if ((targetTagName === 'a') || ((targetTagName === 'img') && (target.parentNode.tagName.toLowerCase() === 'a')) || this.props.dataEventName) {
        if (targetTagName === 'img') {
          trackableElement = target.parentNode;
          innerHTML = target.src.substring(target.src.lastIndexOf('/') + 1).split('?')[0];
        } else {
          ({ innerHTML } = target);
        }
      }
      const destinationUrl = trackableElement.getAttribute('href');
      const linkType = trackableElement.getAttribute('data-link-type') || 'text-link';
      const articleClickedTracker = {
        destinationUrl,
        module: 'honoree-grid-logo',
        hypercontext: innerHTML, // need to handle this more elegantly
        category: linkType,
        linkType,
        label: destinationUrl,
      };
      segmentTrackEvent('article_clicked', articleClickedTracker);
  }

  componentDidMount() {
    segmentTrackPage();
  }

  componentDidUpdate(prevProps) {
    
  }

  renderArticles(articles, isMobile) {
    const renderedArticles = articles.map((article, a) => {
      //code for rendering the collection of articles/sections for the lander, call 'handleClick' onClick of each rendered article/section object so it can be tracked properly
    });
    return renderedArticles;
  }

  render() {
    const { brand, isLoading, meta, logo, isMobile, trackingPixels } = this.props;
    if (isLoading) {
      return <Loading />;
    }
    const className = `${brand} lander`;
    let timestamp = Date.now();
    return (
      <Fragment>
        <MetaTags
          title={meta.title}
          description={meta.description}
          url={meta.url}
          ogType="lander"
          ogTitle={meta.fbTitle}
          ogDescription={meta.fbDescription}
          ogImage={meta.fbImage}
          ogImageWidth="600px"
          ogImageHeight="600px"
          twitterDescription={meta.description}
          twitterImg={meta.image}
          canonicalUrl={meta.url} />
          <TrackingPixels timestamp={timestamp} trackingPixels={trackingPixels} />

      </Fragment>
    );
  }
}
const mapState = (state) => {
  const { pageData, isMobile } = state;
  const { pageType, articles, brand, logo, meta, trackingPixels } = pageData;
  /*
    Handles first action dispatched when clicking redux-first-router Link or NavLink.

    This first action just updates the location in the redux store but doesn't fetch any data
    or update the actual contents of the page.

    A second action is dispatched once the thunk associated with the new route/location finishes running.
    In this case, the thunk internally makes an async request to the server to get new data based on the redux
    state's location.
  */

  console.log(pageType);

  if (pageType !== "lander") {

    return {
      articles: [],
      brand: '',
      isLoading: true,
    };
  }

  return {
    pageType,
    isMobile,
    articles, 
    brand, 
    isLoading: false,
    logo,
    meta,
    trackingPixels,
  }
}
export default connect(mapState)(Lander);

